import { skipToken } from '@reduxjs/toolkit/query';
import { useGetCommerceSettingsQuery } from '../services/commerce-settings.service';
import { CommerceSettingsFilters } from '../models';

interface UseCommerceSettingsProps {
  filters?: CommerceSettingsFilters;
  page: number;
  pageSize: number;
  skip?: boolean;
}

const useCommerceSettings = ({
  filters,
  page,
  pageSize,
  skip,
}: UseCommerceSettingsProps) => {
  const { data, isLoading, error } = useGetCommerceSettingsQuery(
    skip
      ? skipToken
      : {
          paginated: { page, pageSize },
          filters,
        }
  );

  const count = data?.count ?? 0;
  const rows = data?.items ?? [];

  return {
    isLoading,
    error,
    commerceSettings: rows,
    totalItems: count,
    totalPages: Math.ceil(count / pageSize),
  };
};

export default useCommerceSettings;
